// @flow

import type { State }   from '../../store';
import isStorageAllowed from '../../utils/cookieSettings/isStorageAllowed';


// -----------------------------------------------------------------------------------------------------------------
// Main function
// -----------------------------------------------------------------------------------------------------------------

/**
 * Args are included here so that calls to the function do not report incorrect arguments, however the Google Analytics
 * code required that you push `arguments` onto the dataLayer, rather than args, for some reason.
 *
 * @param args
 */
function gtag(...args: *): void {

  const state: State = require('../../store').getStore().getState();

  if (!isStorageAllowed('analytics', state)) {
    return;
  }
  
  // DO NOT use args for push() call, as it doesn't work correctly.
  // You must use arguments instead for some reason.
  window.dataLayer.push(arguments);
}


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default gtag;



// WEBPACK FOOTER //
// ./src/analytics/google-analytics/gtag.js